module.exports = __webpack_public_path__ + "static/media/secure_your_loved_one_icon.47433404.png";